<template>
  <iframe
    :src="url"
    frameborder="0"
    style="
      width: 100%;
      height: calc(100vh - 85px);
      overflow-y: scroll;
      border: none;
      overflow: hidden;
    "
  />
</template>

<script>
  import Vue from 'vue'
  import { CountDown } from 'vant'

  Vue.use(CountDown)

  export default {
    name: 'Found',
    data() {
      return {
        url: null,
        urlMap: {
          1: 'https://tyw.zwqeq.site/',
          4: 'https://cad.zwqeq.site/',
        },
      }
    },
    created() {
      this.$parent.footer('found', true)
      let id = this.$route.query.id || 1
      this.url = this.urlMap[id]
    },
    mounted() {},
    methods() {},
  }
</script>
<style>
  iframe {
    position: absolute;
    display: block;
    border: 0px;
    top: 0px;
    left: 0px;
    width: 100%;
  }
</style>
